import { ManifestError } from './ManifestError';

export class ManifestResponse {
  success?: boolean;
  manifestId?: number;
  manifestNumber?: string;
  errors: ManifestError[] = [];
  shipmentIds: number[] = [];

  constructor(opts?: Partial<ManifestResponse>) {
    if (opts?.success != null) {
      this.success = opts.success;
    }
    if (opts?.manifestId != null) {
      this.manifestId = opts.manifestId;
    }
    if (opts?.manifestNumber != null) {
      this.manifestNumber = opts.manifestNumber;
    }
    if (opts?.errors != null) {
      this.errors = opts.errors.map((val) => new ManifestError(val));
    }
    if (opts?.shipmentIds != null) {
      this.shipmentIds = [...opts.shipmentIds];
    }
  }
}
